module.exports = __webpack_public_path__ + "img/hero.04b6e348.png";